import React, { useState, useEffect } from "react";
import { getHostelDetail } from "../../../../services/hostelApiService/hostelService";
import { Spinner } from "react-bootstrap";

const HostelManagement = ({ userId }) => {
    const [hostelData, setHostelData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (userId) {
            fetchHostelData();
        }
    }, [userId]);

    const fetchHostelData = async () => {
        setIsLoading(true);
        try {
            const response = await getHostelDetail(userId);
            if (response?.data) {
                setHostelData(response.data);
            } else {
                setError("No hostel details found");
            }
        } catch (err) {
            console.error("Error fetching hostel data:", err);
            setError("Failed to load hostel details");
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    if (isLoading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (error || !hostelData) {
        return <div className="text-muted py-2 text-center">{error || "No hostel data available"}</div>;
    }

    return (
        <div className="py-2">
            <div className="row">
                <div className="col-md-3 mb-3">
                    <label className="form-label text-muted mb-1">Hostel Name</label>
                    <div className="fw-medium">{hostelData.hostelName || "N/A"}</div>
                </div>
                <div className="col-md-3 mb-3">
                    <label className="form-label text-muted mb-1">Address</label>
                    <div className="fw-medium">{hostelData.address || "N/A"}</div>
                </div>
                <div className="col-md-3 mb-3">
                    <label className="form-label text-muted mb-1">Room Type</label>
                    <div className="fw-medium">{hostelData.roomType || "N/A"}</div>
                </div>
                <div className="col-md-3 mb-3">
                    <label className="form-label text-muted mb-1">Room Name</label>
                    <div className="fw-medium">{hostelData.roomName || "N/A"}</div>
                </div>
                <div className="col-md-3 mb-3">
                    <label className="form-label text-muted mb-1">Bed Number</label>
                    <div className="fw-medium">{hostelData.bedNumber || "N/A"}</div>
                </div>
                <div className="col-md-3 mb-3">
                    <label className="form-label text-muted mb-1">Start Date</label>
                    <div className="fw-medium">{formatDate(hostelData.startDate)}</div>
                </div>
                <div className="col-md-3 mb-3">
                    <label className="form-label text-muted mb-1">End Date</label>
                    <div className="fw-medium">{formatDate(hostelData.endDate)}</div>
                </div>
            </div>
        </div>
    );
};

export default HostelManagement;
